import { Image } from '../Image';
import { getDefaultColor } from '../utils/getDefaultColor';
import { getOutputImage, maskToOutputMask } from '../utils/getOutputImage';
import checkProcessable from '../utils/validators/checkProcessable';
/**
 * Draw a rectangle defined by position of the top-left corner, width and height.
 * @param image - Image to process.
 * @param options - Draw rectangle options.
 * @returns The image with the rectangle drawing.
 */
export function drawRectangle(image, options = {}) {
    const { width: rectangleWidth = image.width, height: rectangleHeight = image.height, origin = { column: 0, row: 0 }, strokeColor = getDefaultColor(image), fillColor = 'none', } = options;
    const width = Math.round(rectangleWidth);
    const height = Math.round(rectangleHeight);
    const column = Math.round(origin.column);
    const row = Math.round(origin.row);
    let newImage;
    if (image instanceof Image) {
        checkProcessable(image, {
            bitDepth: [8, 16],
        });
        newImage = getOutputImage(image, options, { clone: true });
    }
    else {
        newImage = maskToOutputMask(image, options, { clone: true });
    }
    if (strokeColor !== 'none') {
        for (let currentColumn = column; currentColumn < column + width; currentColumn++) {
            newImage.setVisiblePixel(currentColumn, row, strokeColor);
            newImage.setVisiblePixel(currentColumn, row + height - 1, strokeColor);
        }
        for (let currentRow = row + 1; currentRow < row + height - 1; currentRow++) {
            newImage.setVisiblePixel(column, currentRow, strokeColor);
            newImage.setVisiblePixel(column + width - 1, currentRow, strokeColor);
        }
    }
    if (fillColor !== 'none') {
        for (let currentRow = row + 1; currentRow < row + height - 1; currentRow++) {
            for (let currentColumn = column + 1; currentColumn < column + width - 1; currentColumn++) {
                newImage.setVisiblePixel(currentColumn, currentRow, fillColor);
                newImage.setVisiblePixel(currentColumn, currentRow, fillColor);
            }
        }
    }
    return newImage;
}
//# sourceMappingURL=drawRectangle.js.map